import React from "react";
import { connect } from 'react-redux';
import RadioButton from '@zacousticrepo/grommet-v1-custom/components/RadioButton';
import EditProfileIcon from '../../../icons/v3/EditProfileIcon';
import UserAvatar from '../../../icons/v3/UserAvatar';
import moment from 'moment';
import 'moment-duration-format';
import { arrayIsNotEmpty, isDefined } from "../../../utils";
import { roleType } from '../../../constants';

class UserProfileEditor extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showTerminateMessage: false,
            showActivateMessage: false,
            selectedTeamId: props.userToShow.teamId,
            selectedUserDirectAccessResourceIds: isDefined(props.userToShow.teamId) ? props.userToShow.teamId.split(", ").map(Number) : []
        };
    }

    onShowTerminateMessage = () => {
        this.setState({ showTerminateMessage: true });
    }

    onHideTerminateMessage = () => {
        this.setState({ showTerminateMessage: false });
    }

    onShowActivateMessage = () => {
        this.setState({ showActivateMessage: true });
    }

    onHideActivateMessage = () => {
        this.setState({ showActivateMessage: false });
    }
    
    onUpdateUser = () => {
        const
            {
                onUpdateUser,
                userToShow
            } = this.props;
        const userUpdateInfo = {
            id: userToShow.id,
            TeamId: this.state.selectedTeamId,
            RoleId: this.state.roleId,
            ResourceIds: this.state.selectedUserDirectAccessResourceIds
        };

        onUpdateUser(userUpdateInfo)
    }

    selectSurveyFormType = (roleId) => {
        this.setState({ roleId: roleId });
    }

    handleTeamChange = (event) => {
        this.setState({ selectedTeamId: parseInt(event.target.value) });
    }

    selectTeam = (teamId) => {
        this.setState({ selectedTeamId: teamId });
    }

    handleCheckboxChange = (id) => {
        const { selectedUserDirectAccessResourceIds } = this.state;
        if (selectedUserDirectAccessResourceIds.includes(id)) {
            this.setState({
                selectedUserDirectAccessResourceIds: selectedUserDirectAccessResourceIds.filter((selectedId) => selectedId !== id)
            });
        } else {
            this.setState({
                selectedUserDirectAccessResourceIds: [...selectedUserDirectAccessResourceIds, id]
            });
        }
    }

    render() {
        const
            {
                userToShow,
                terminateUser,
                activateUser,
                allTeams,
                domainValues
            } = this.props;
        if (!isDefined(userToShow) || !arrayIsNotEmpty(domainValues)) {
            return <div></div>;
        }

        const sitesDomain = domainValues.find(dv => dv.domainName === "Site");
        const managersDomain = domainValues.find(dv => dv.domainName === "Manager");
        const supervisorsDomain = domainValues.find(dv => dv.domainName === "Supervisor");

        const sites = (isDefined(sitesDomain) && arrayIsNotEmpty(sitesDomain.domainValues))
            ? [...sitesDomain.domainValues].sort((a, b) => {
                return a.domainValueName.localeCompare(b.domainValueName);
            }) : undefined;

        const managers = (isDefined(managersDomain) && arrayIsNotEmpty(managersDomain.domainValues))
            ? [...managersDomain.domainValues].sort((a, b) => {
                return a.domainValueName.localeCompare(b.domainValueName);
            }) : undefined;

        const supervisors = (isDefined(supervisorsDomain) && arrayIsNotEmpty(supervisorsDomain.domainValues))
            ? [...supervisorsDomain.domainValues].sort((a, b) => {
                return a.domainValueName.localeCompare(b.domainValueName);
            }) : undefined;

        const distinctTeams = allTeams.reduce((acc, current) => {
            if (isDefined(current.id) && isDefined(current.name) && !acc.some(item => item.teamId === current.id)) {
                acc.push({ team: current.name, teamId: current.id });
            }
            return acc;
        }, []);

        const sortedDistinctTeams = [...distinctTeams].sort((a, b) => {
            return a.team.localeCompare(b.team);
        });

        return (<div
            style={{
                margin: '30px',
                backgroundImage: `url(${`../../../../Assets/Images/V3Design/seamless-pattern-floral.svg`})`
            }} >
            {/*<div>
                <EditProfileIcon />
            </div>*/ }
            <div className="align-items-center-horizontal" >
                <div style={{ width: '48px', height: '48px' }}>
                    <UserAvatar />
                </div>
                <div style={{ margin: '20px 0' }}>
                    {userToShow.isTerminated && <div className="terminated-user">Terminated</div>}
                </div>
                <div className="text-primary-color text-600-20-23" style={{ margin: '20px 0' }}>
                    {userToShow.agent}
                </div>
                <div style={{ margin: '10px 0' }}>
                    {userToShow.userName}
                </div>
                <div style={{ margin: '12px 0' }}>
                    {userToShow.role} {userToShow.teams && <span>in {userToShow.teams}</span>}
                </div>
            </div>
            <div style={{ margin: '12px auto' }}>
                <div className="eighteen-regular-primary-color " style={{ margin: '17px 0 16px 0' }}>Role</div>
                <div className="radio-button-text">
                    <div style={{ margin: '10px' }}>
                        <RadioButton id="agent" label='Agent' checked={this.state.roleId === roleType.agent}
                            onChange={() => this.selectSurveyFormType(roleType.agent)} />
                    </div>
                    <div style={{ margin: '10px' }}>
                        <RadioButton id="supervisor" label='supervisor' checked={this.state.roleId === roleType.supervisor}
                            onChange={() => this.selectSurveyFormType(roleType.supervisor)} />

                    </div>
                    <div style={{ margin: '10px' }}>
                        <RadioButton id="manager" label='manager' checked={this.state.roleId === roleType.manager}
                            onChange={() => this.selectSurveyFormType(roleType.manager)} />
                    </div>
                    <div style={{ margin: '10px' }}>
                        <RadioButton id="admin" label='admin' checked={this.state.roleId === roleType.admin}
                            onChange={() => this.selectSurveyFormType(roleType.admin)} />
                    </div>
                    <div style={{ margin: '10px' }}>
                        <RadioButton id="superAdmin" label='superAdmin' checked={this.state.roleId === roleType.superAdmin}
                            onChange={() => this.selectSurveyFormType(roleType.superAdmin)} />
                    </div>
                </div>
            </div>
            {userToShow.roleId == 1 && <div>
                <div className="eighteen-regular-primary-color " style={{ margin: '17px 0 16px 0' }}>Team</div>
                <div className="bordered-div" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                    {sortedDistinctTeams.map(team => (
                        <div className="radio-button-text" key={team.teamId}>
                            <div style={{ margin: '10px' }}>
                                <RadioButton id={team.teamId} label={team.team} checked={this.state.selectedTeamId == team.teamId}
                                    onChange={() => this.selectTeam(team.teamId)} />
                            </div>
                        </div>
                    ))}
                </div>
            </div>}
            {userToShow.roleId > 1 && <div>
                <div className="eighteen-regular-primary-color " style={{ margin: '17px 0 16px 0' }}>Select Access:</div>
                <div className="eighteen-regular-primary-color " style={{ margin: '17px 0 16px 0' }}>Sites</div>
                <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                    {sites.map((t, i) => {
                        return <div className="flex" style={{ width: 'max-content', margin: '2px 0' }} key={i}>
                            <input
                                type="checkbox"
                                id={t.domainValueId}
                                value={t.domainValueId}
                                checked={this.state.selectedUserDirectAccessResourceIds.includes(t.domainValueId)}
                                onChange={() => this.handleCheckboxChange(t.domainValueId)}
                                className="checkbox-custom"
                            />
                            <label htmlFor={t.domainValueId}>{t.domainValueName}</label>
                        </div>
                    })}
                </div>
                <div className="eighteen-regular-primary-color " style={{ margin: '17px 0 16px 0' }}>Managers</div>
                <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                    {managers.map((t, i) => {
                        return <div className="flex" style={{ width: 'max-content', margin: '2px 0' }} key={i}>
                            <input
                                type="checkbox"
                                id={t.domainValueId}
                                value={t.domainValueId}
                                checked={this.state.selectedUserDirectAccessResourceIds.includes(t.domainValueId)}
                                onChange={() => this.handleCheckboxChange(t.domainValueId)}
                                className="checkbox-custom"
                            />
                            <label htmlFor={t.domainValueId}>{t.domainValueName}</label>
                        </div>
                    })}
                </div>
                <div className="eighteen-regular-primary-color " style={{ margin: '17px 0 16px 0' }}>Supervisorss</div>
                <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                    {supervisors.map((t, i) => {
                        return <div className="flex" style={{ width: 'max-content', margin: '2px 0' }} key={i}>
                            <input
                                type="checkbox"
                                id={t.domainValueId}
                                value={t.domainValueId}
                                checked={this.state.selectedUserDirectAccessResourceIds.includes(t.domainValueId)}
                                onChange={() => this.handleCheckboxChange(t.domainValueId)}
                                className="checkbox-custom"
                            />
                            <label htmlFor={t.domainValueId}>{t.domainValueName}</label>
                        </div>
                    })}
                </div>
            </div>}
            <div className="align-items-center-horizontal" >
                <div className="v3-button agent-view-interactions"
                    style={{ background: '#E6F7F8', padding: '13px 17px' }} onClick={this.onUpdateUser}>Update</div>
                {!userToShow.isTerminated && !this.state.showTerminateMessage &&
                    <div className="v3-button agent-view-interactions"
                        style={{ background: '#E6F7F8', padding: '13px 17px' }} onClick={this.onShowTerminateMessage}>Terminate</div>
                }
                {!userToShow.isTerminated && this.state.showTerminateMessage &&
                    <div style={{
                        backgroundColor: '#cabfe2', padding: '20px'
                    }}>
                        <div>Are you sure you want to terminate user? </div>
                        <div className="flex justify-content-space-evenly">
                            <div className="v3-button agent-view-interactions"
                                style={{ background: '#E6F7F8', padding: '13px 17px' }} onClick={this.onHideTerminateMessage}>No</div>
                            <div className="v3-button agent-view-interactions"
                                style={{ background: '#E6F7F8', padding: '13px 17px' }} onClick={() => terminateUser(userToShow.id)}>Yes</div>
                        </div>
                    </div>
                }
                {userToShow.isTerminated && !this.state.showActivateMessage &&
                    <div className="v3-button agent-view-interactions"
                        style={{ background: '#E6F7F8', padding: '13px 17px' }} onClick={this.onShowActivateMessage}>Activate</div>
                }
                {userToShow.isTerminated && this.state.showActivateMessage &&
                    <div style={{
                        backgroundColor: '#cabfe2', padding: '20px'
                    }}>
                        <div>Are you sure you want to activate user? </div>
                        <div className="flex justify-content-space-evenly">
                            <div className="v3-button agent-view-interactions"
                                style={{ background: '#E6F7F8', padding: '13px 17px' }} onClick={this.onHideActivateMessage}>No</div>
                            <div className="v3-button agent-view-interactions"
                                style={{ background: '#E6F7F8', padding: '13px 17px' }} onClick={() => activateUser(userToShow.id)}>Yes</div>
                        </div>
                    </div>
                }
                {userToShow.terminationDate &&
                    <div>
                        TerminationDate: {moment(userToShow.terminationDate).format('M/D/YYYY')}
                    </div>}
            </div>
        </div>);
    };
}

const select = state => ({});

export default connect(select)(UserProfileEditor);

